export default {
  mobileLanding: {
    media: {
      appPreview: "Prévia animada do app",
      leagues: "Tela de seleção de ligas",
      trendFlow: "Fluxo animado de tendências",
      trendAnalysis: "Tela detalhada de análise de tendência",
      myPicks: "Tela Minhas escolhas",
      checkout: "Tela de checkout",
    },
    sections: {
      research: {
        heading: "Vá da pesquisa à aposta em segundos",
        body: "O Linemate faz a pesquisa por você, analisando tendências e matchups para que você vá de insight a aposta sem horas procurando.",
      },
      leagues: {
        body: "Escolha entre mais de 18 grandes ligas para explorar tendências e jogadas adaptadas aos jogos e jogadores que mais importam para você.",
      },
      trends: {
        body: "Navegue pelas tendências de melhor desempenho e escolha uma jogada apoiada por dados reais, desempenho recente e contexto relevante.",
      },
      analysis: {
        body: "Aprofunde-se em cada jogada com análises claras de desempenho, contexto situacional e os principais sinais que impulsionam a tendência.",
      },
      odds: {
        body: "Encontre as melhores odds disponíveis entre operadores e tire o máximo valor de cada aposta.",
      },
      checkout: {
        body: "Finalize em segundos com seu betslip preenchido automaticamente no seu operador preferido.",
      },
    },
    cta: {
      titleLineOne: "Sua casa",
      titleLineTwo: "para cada aposta",
    },
  },
};
